import Vue from 'vue'
import JsonApiObject from '@/_models/JsonApi'

import StringModel from '@/views/Language/models/string'
import TagModel from '@/views/Language/models/tag'
import LanguageStatisticsModel from '@/views/Language/models/languageStatistics'
import StringGroupInput from '@/views/Language/dialogs/stringGroupInput/stringGroupInput.vue'
import ConfirmDelete from '@/views/Language/dialogs/confirmDelete/confirmDelete.vue'
import StringInput from '@/views/Language/dialogs/stringInput/stringInput.vue'
import StringGroupAttachmentModel from './stringGroupAttachment'
export default class StringGroupModel extends JsonApiObject {
    static async initPost(stringGroup: null, stringGroups: Array<StringGroupModel>) {
        return await JsonApiObject.openDialog(StringGroupInput, {
            stringGroup,
            stringGroups,
        })
    }

    static async post(data: any) {
        let query = {
            include: ['tags', 'statistics.language', 'attachments'],
            body: { data: data },
        }

        let res = await Vue.prototype.$vbit.post('language', `stringGroups`, query)

        return res.data ? new StringGroupModel(res.data, res.included) : res
    }

    static async get(stringGroupId: string, token: string | null = null) {
        let query = {
            ...(token && {
                token,
            }),
            include: [
                'strings.translations.textHistory',
                'strings.tokens',
                'strings.attachments',
                'tags',
                'statistics',
                'attachments',
            ],
        }

        let res = await Vue.prototype.$vbit.get('language', `stringGroups/${stringGroupId}`, query)

        return res.data ? new StringGroupModel(res.data, res.included) : res
    }

    static async getAllStringGroups(token: string | null = null) {
        let query = {
            include: ['tags', 'statistics.language', 'attachments'],
            ...(token && {
                token,
            }),
        }

        let res = await Vue.prototype.$vbit.get('language', `stringGroups`, query)

        let stringGroups = res.data.map(
            (stringGroup) => new StringGroupModel(stringGroup, res.included)
        )

        return stringGroups
    }

    public constructor(data: any, included?) {
        super(data, included)
    }

    name
    description
    deleted
    createdAt
    updatedAt

    get strings(): Array<StringModel> {
        return this._relationships['strings'] ? this._relationships['strings'] : []
    }

    set strings(strings: Array<StringModel>) {
        this._relationships['strings'] = strings
    }

    get tags(): Array<TagModel> {
        return this._relationships['tags'] ? this._relationships['tags'] : []
    }

    set tags(tags: Array<TagModel>) {
        this._relationships['tags'] = tags
    }

    hasTag(searchTag: string) {
        return this.tags.findIndex((tag) => tag._id == searchTag) > -1 ? true : false
    }

    get attachments(): Array<StringGroupAttachmentModel> {
        return this._relationships['attachments'] ? this._relationships['attachments'] : []
    }

    set attachments(attachments: Array<StringGroupAttachmentModel>) {
        this._relationships['attachments'] = attachments
    }

    get statistics(): Array<LanguageStatisticsModel> {
        return this._relationships['statistics'] ? this._relationships['statistics'] : []
    }

    async get() {
        let query = {
            include: ['tags', 'statistics.language', 'attachments'],
        }
        let res = await Vue.prototype.$vbit.get('language', `stringGroups/${this._id}`, query)
        return this.initalize(res.data, res.included)
    }

    async delete() {
        let res = await JsonApiObject.openDialog(ConfirmDelete, {
            name: this.name,
            deleted: this.deleted,
            type: 'stringGroup',
            needConfirm: false,
        })
        if (res) {
            let data = {
                id: this._id,
                type: this._type,
                attributes: {
                    deleted: !this.deleted,
                },
            }

            return await this.patch(data)
        }
    }

    async initiatePatch(stringGroup: StringGroupModel, stringGroups: Array<StringGroupModel>) {
        return await JsonApiObject.openDialog(StringGroupInput, {
            stringGroup,
            stringGroups,
        })
    }

    async patch(data: any) {
        let query = {
            include: ['tags', 'statistics.language', 'attachments'],
            updatedAt: this['updatedAt'],
            body: { data: data },
        }

        let res = await Vue.prototype.$vbit.patch('language', `stringGroups/${this._id}`, query)

        return res.data ? this.initalize(res.data, res.included) : res
    }

    async initPostString(string: null, strings: Array<StringModel>, stringGroup: StringGroupModel) {
        return await JsonApiObject.openDialog(StringInput, {
            string,
            strings,
            stringGroup,
        })
    }

    async postString(data: any) {
        let string = await StringModel.post(data)
        this.strings = [...this.strings, string]
        return string
    }

    async postAttachment(fileId: string) {
        let query = {
            include: ['tags', 'statistics.language', 'attachments'],
            body: {
                data: {
                    type: 'stringGroupAttachment',
                    attributes: {
                        fileId,
                    },
                    relationships: {
                        group: {
                            data: {
                                type: this._type,
                                id: this._id,
                            },
                        },
                    },
                },
            },
        }

        let res = await Vue.prototype.$vbit.post('language', `stringGroupAttachments`, query)

        if (res.data) {
            let attachment = new StringGroupAttachmentModel(res.data, res.included)
            this.attachments = [...this.attachments, attachment]
            return attachment
        } else {
            return res
        }
    }
}
